import * as React from 'react';

import { Heading } from '@built/design-system';

import ActionButton from '../containers/ActionButton';
import * as styles from './SetupComplete.module.scss';

export default class SetupComplete extends React.Component<SetupCompleteProps> {
  render() {
    return (
      <div className={styles.verticalSpacing}>
        <Heading size="xxl">Thanks! You're good to go!</Heading>

        <p className={styles.lead}>
          The security for your account <strong>{this.props.email}</strong> has
          been sucessfully upgraded. Please continue to your Built account
          below.
        </p>

        <form onSubmit={this.props.handleSubmit}>
          <p>
            <ActionButton
              label="Continue"
              loading={this.props.busy}
              type="submit"
            />
          </p>
        </form>
      </div>
    );
  }
}

export interface SetupCompleteProps {
  email: string;
  busy: boolean;
  handleSubmit(event: React.SyntheticEvent<HTMLFormElement>): void;
}



// WEBPACK FOOTER //
// ./src/components/SetupComplete.tsx